import React, { Component } from 'react';
import { Link } from 'react-router-dom';

import LazyImage from 'components/LazyImage';

import img1 from 'shared/img/tm-colorit-1.webp';
import img1Sm from 'shared/img/tm-colorit-1-sm.webp';
import img2 from 'shared/img/tm-colorit-2.webp';
import img2Sm from 'shared/img/tm-colorit-2-sm.webp';
import img3 from 'shared/img/tm-colorit-3.webp';
import img3Sm from 'shared/img/tm-colorit-3-sm.webp';
import img4 from 'shared/img/tm-colorit-4.webp';
import img4Sm from 'shared/img/tm-colorit-4-sm.webp';
import img5 from 'shared/img/tm-colorit-5.webp';
import img5Sm from 'shared/img/tm-colorit-5-sm.webp';
import img6 from 'shared/img/tm-colorit-6.webp';
import img6Sm from 'shared/img/tm-colorit-6-sm.webp';
import img7 from 'shared/img/tm-colorit-7.webp';
import img7Sm from 'shared/img/tm-colorit-7-sm.webp';
import img8 from 'shared/img/tm-colorit-8.webp';
import img8Sm from 'shared/img/tm-colorit-8-sm.webp';
import img9 from 'shared/img/tm-colorit-9.webp';
import img9Sm from 'shared/img/tm-colorit-9-sm.webp';
import img10 from 'shared/img/tm-colorit-10.webp';
import img10Sm from 'shared/img/tm-colorit-10-sm.webp';
import img11 from 'shared/img/tm-colorit-11.webp';
import img11Sm from 'shared/img/tm-colorit-11-sm.webp';
import img12 from 'shared/img/tm-colorit-12.webp';
import img12Sm from 'shared/img/tm-colorit-12-sm.webp';
import imgColor from 'shared/img/tm-color.webp'
import imgColorSm from 'shared/img/tm-color-sm.webp'
import colorLogo from 'shared/img/color-logo.webp'

class TmColorit extends Component {
  render() {
    const { style } = this.props;

    return(
      <div className={style.root}>
        <div className={style.row}>
          <div className={style.col}>
            <div className={style.wrapperOne}>
              <div className={style.contentOne}>
                <h2 className={style.heading}>Канцтовари, якими ми пишаємся щодня</h2>
                <p className={style.text}>Це наша власна лінійка канцелярії — стильна, якісна та за доступною ціною, яка вас точно порадує.</p>
              </div>
              <LazyImage
                image={{
                  className: style.bgImage,
                  src: img1,
                  alt: "",
                  lowResSrc: img1Sm
                }}
              />
            </div>
          </div>
        </div>
        <div className={style.row}>
          <div className={style.col}>
            <Link className={style.wrapperTow} to='/catalog/10200'>
              <div className={style.contentTow}>
                <h2 className={style.heading}>Фотопапір</h2>
                <p className={style.text}>Яскравість спогадів у кожному відбитку</p>
                <Link className={style.linkBtn} to='/catalog/10200'>Дивитися всі відтінки</Link>
              </div>
              <LazyImage
                image={{
                  className: style.bgImage,
                  src: img2,
                  alt: "",
                  lowResSrc: img2Sm
                }}
              />
            </Link>
          </div>
        </div>
        <div className={style.row}>
          <div className={style.rowGrid}>
            <div className={style.col}>
              <Link className={style.wrapperThree} to='/catalog/50830'>
                <div className={style.contentThree}>
                  <h2 className={style.heading}>Олівці кольорові</h2>
                  <p className={style.text}>Магія кольору у ваших руках!</p>
                  <Link className={style.linkBtn} to='/catalog/50830'>Купити</Link>
                </div>
                <LazyImage
                  image={{
                    className: style.bgImage,
                    src: img3,
                    alt: "",
                    lowResSrc: img3Sm
                  }}
                />
              </Link>
            </div>
            <div className={style.col}>
              <Link className={style.wrapperFour} to='/catalog/10991'>
                <div className={style.contentFour}>
                  <h2 className={style.heading}>Нехай ваші ідеї оживають з легкістю в кожному штриху!</h2>
                  <Link className={style.linkBtn} to='/catalog/10991'>В магазин</Link>
                </div>
                <LazyImage
                  image={{
                    className: style.bgImage,
                    src: img4,
                    alt: "",
                    lowResSrc: img4Sm
                  }}
                />
              </Link>
            </div>
          </div>
          <div className={style.rowGrid}>
            <div className={style.col}>
              <Link className={style.wrapperFive} to='/catalog/10995'>
                <div className={style.contentFive}>
                  <h2 className={style.heading}>Акварель</h2>
                  <p className={style.text}>Ідеальні художні товари для тих, хто хоче творити та надихатися!</p>
                  <Link className={style.linkBtn} to='/catalog/10995'>В магазин</Link>
                </div>
                <LazyImage
                  image={{
                    className: style.bgImage,
                    src: img5,
                    alt: "",
                    lowResSrc: img5Sm
                  }}
                />
              </Link>
            </div>
            <div className={style.col}>
              <Link className={style.wrapperSix} to='/catalog/10988'>
                <div className={style.contentSix}>
                  <h2 className={style.heading}>Офісне приладдя</h2>
                  <p className={style.text}>Порядок, мінімалізм, зручність та стиль — усе для ідеального офісу</p>
                  <Link className={style.linkBtn} to='/catalog/10988'>Купити</Link>
                </div>
                <LazyImage
                  image={{
                    className: style.bgImage,
                    src: img6,
                    alt: "",
                    lowResSrc: img6Sm
                  }}
                />
              </Link>
            </div>
          </div>
        </div>
        <div className={style.row}>
          <div className={style.col}>
            <Link className={style.wrapperSeven} to='/catalog/110171'>
              <div className={style.contentSeven}>
                <h2 className={style.heading}>Маркери</h2>
                <p className={style.text}>Виділяй важливе</p>
                <Link className={style.linkBtn} to='/catalog/110171'>Переглянути в магазині</Link>
              </div>
              <LazyImage
                  image={{
                    className: style.bgImage,
                    src: img7,
                    alt: "",
                    lowResSrc: img7Sm
                  }}
                />
            </Link>
          </div>
        </div>
        <div className={style.row}>
          <div className={style.rowGrigT}>
            <div className={style.col}>
              <Link className={style.wrapperEight} to='/catalog/50369'>
                <div className={style.contentEight}>
                  <h2 className={style.heading}>Коректори</h2>
                  <p className={style.text}>Корекція без меж – точність у кожному русі!</p>
                  <Link className={style.linkBtn} to='/catalog/50369'>В магазин</Link>
                </div>
                <LazyImage
                  image={{
                    className: style.bgImage,
                    src: img8,
                    alt: "",
                    lowResSrc: img8Sm
                  }}
                />
              </Link>
            </div>
            <div className={style.col}>
              <div className={style.rowCol}>
                <div className={style.col}>
                  <Link className={style.wrapperNine} to='catalog/116894'>
                    <div className={style.contentNine}>
                      <h2 className={style.heading}>Скетч-маркери</h2>
                    </div>
                    <LazyImage
                      image={{
                        className: style.bgImage,
                        src: img9,
                        alt: "",
                        lowResSrc: img9Sm
                      }}
                    />
                  </Link>
                </div>
              </div>
              <div className={style.rowGridS}>
                <div className={style.colH}>
                  <Link className={style.wrapperTen} to='/catalog/50874'>
                    <div className={style.contentTen}>
                      <h2 className={style.heading}>Фломастер дитячий</h2>
                      <p className={style.text}>Світ у кольорі очима дитини</p>
                      <Link className={style.linkBtn} to='/catalog/50874'>Купити</Link>
                    </div>
                    <LazyImage
                      image={{
                        className: style.bgImage,
                        src: img10,
                        alt: "",
                        lowResSrc: img10Sm
                      }}
                    />
                  </Link>
                </div>
                <div className={style.colH}>
                  <Link className={style.wrapperEleven} to='/catalog/50334'>
                    <div className={style.contentEleven}>
                      <h2 className={style.heading}>Клей-олівець</h2>
                      <p className={style.text}>Чистий результат</p>
                      <Link className={style.linkBtn} to='/catalog/50334'>Купити</Link>
                    </div>
                    <LazyImage
                      image={{
                        className: style.bgImage,
                        src: img11,
                        alt: "",
                        lowResSrc: img11Sm
                      }}
                    />
                  </Link>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div className={style.row}>
          <div className={style.col}>
            <Link className={style.wrapperTwelve} to='/catalog/10994'>
              <div className={style.contentTwelve}>
                <h2 className={style.heading}>Щоденник</h2>
                <p className={style.text}>Твій персональний простір для ідей</p>
                <Link className={style.linkBtn} to='/catalog/10994'>Обери свій</Link>
              </div>
              <LazyImage
                image={{
                  className: style.bgImage,
                  src: img12,
                  alt: "",
                  lowResSrc: img12Sm
                }}
              />
            </Link>
          </div>
        </div>
        <div className={style.rowColor}>
          <div className={style.col}>
            <div className={style.wrapperColor}>
              <div className={style.contentColor}>
                <img className={style.colorLogo} src={colorLogo} alt="" />
                <h2 className={style.heading}>Якість без компромісів</h2>
                <p className={style.text}>Наша команда доклала чимало зусиль та енергії, щоб сьогодні пропонувати канцелярські товари високої якості за найкращими цінами на ринку. Співвідношення ціни та якості, яке важко перевершити.</p>
                <p className={style.text}>Дякуємо, що залишаєтесь з нами.</p>
                <Link className={style.linkBtn} to='/'>В магазин</Link>
              </div>
              <LazyImage
                image={{
                  className: style.bgImage,
                  src: imgColor,
                  alt: "",
                  lowResSrc: imgColorSm
                }}
              />
            </div>
          </div>
        </div>
      </div>
    )
  }
}

TmColorit.defaultProps = {
  style: require('./TmColorit.module.scss')
}

export default TmColorit;